import api from "./api";
import store from "store";
import { createAlert } from "../../records/Alert";
import { createAlertAction } from "data/app/appActions";
import { notAuthenticated } from "../../data/app/appActions";
import { AxiosError } from "axios";
import i18n from "i18n";
import { getErrorAlert } from "./errors";

// Generic error handling hooks for unexpected errors, these basically include anything above a 401
api.interceptors.response.use(
	response => response,
	(error: AxiosError) => {
		// Network down
		if (!error.response) {
			store.dispatch(
				// Throw an alert
				createAlertAction(
					createAlert({
						title: i18n.t("alerts.networkError.title"),
						status: "error",
						description: i18n.t("alerts.networkError.description"),
					})
				)
			);

			return Promise.reject(error);
		}
		const code = error.response.status;
		if (code === 401) {
			store.dispatch(notAuthenticated());
		}

		const customOpts = error.config?.customOpts;

		// If the caller wants to handle errors just return the error
		// otherwise we dispatch a generic alert
		if (customOpts && customOpts.handleErrors) {
			if (typeof customOpts.handleErrors === "boolean") {
				return Promise.reject(error);
			} else if (
				Array.isArray(customOpts.handleErrors) &&
				customOpts.handleErrors.includes(code)
			) {
				return Promise.reject(error);
			}
		} else {
			if (code > 401) {
				store.dispatch(createAlertAction(getErrorAlert(code, error)));
			}
			return Promise.reject(error);
		}
	}
);
